import { render, staticRenderFns } from "./ChatsView.vue?vue&type=template&id=7683e288&scoped=true&"
import script from "./ChatsView.vue?vue&type=script&lang=js&"
export * from "./ChatsView.vue?vue&type=script&lang=js&"
import style0 from "./ChatsView.vue?vue&type=style&index=0&id=7683e288&lang=stylus&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "7683e288",
  null
  
)

export default component.exports